<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="565">
      <div @click="close" class="close">
        <Icon name="close" />
      </div>

      <v-card class="wrapper">
        <v-overlay :value="saving" absolute>
          <v-progress-circular
            indeterminate
            size="160"
            width="12"
            style="color: #4b5eff"
          />
        </v-overlay>
        <div class="modal_title">Редактировать выбранные</div>

        <!-- вместо названия/базы/скрипта -->
        <div>
          <p class="modal_subtitle">Выбраны обзвоны</p>

          <div class="selected-toggle" @click="calls_open = !calls_open">
            <v-icon small class="mr-1">
              {{ calls_open ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>

            <span class="heading m-0 selected-summary">{{
              selectedCallsSummary
            }}</span>
          </div>

          <v-expand-transition>
            <div v-show="calls_open">
              <v-autocomplete
                v-model="selectedNames"
                :items="allCallNames"
                multiple
                chips
                item-text="name"
                item-value="guid"
              />
            </div>
          </v-expand-transition>
        </div>

        <!-- <div>
          <p class="modal_subtitle">База контактов</p>
          <v-text-field height="40" :value="selectedLabel" disabled />
        </div>

        <div>
          <p class="modal_subtitle">Сценарий звонка</p>
          <v-text-field height="40" :value="selectedLabel" disabled />
        </div> -->

        <!-- Исходящие номера (как в CreateCall.vue) -->
        <div class="heading">Исходящие номера</div>
        <v-radio-group v-model="data_local.outbound_mode" class="mih40">
          <!-- <v-radio
            label="Стандартные номера"
            value="standard"
            color="#4B5EFF"
          /> -->
          <v-radio
            :disabled="!hasActiveCarousels"
            label="Все активные карусели"
            value="all_active"
            color="#4B5EFF"
          />
          <v-radio
            :disabled="!hasActiveCarousels"
            label="Выбрать карусели"
            value="carousels"
            color="#4B5EFF"
          />
        </v-radio-group>

        <div v-if="data_local.outbound_mode === 'carousels'">
          <v-autocomplete
            class="mih40 multi-wrap"
            hide-details="auto"
            multiple
            clearable
            item-color="#4B5EFF"
            :items="activeCarousels"
            item-value="id"
            item-text="name"
            v-model="data_local.outbound_carousels"
            :rules="carouselsRules"
            solo
            placeholder="Выберите карусели (только Активна)"
            no-data-text="Нет активных каруселей"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="index < 5"
                small
                label
                class="chip-truncate"
                close
                @click:close="
                  data_local.outbound_carousels =
                    data_local.outbound_carousels.filter((id) => id !== item.id)
                "
              >
                {{ item.name }}
              </v-chip>
              <span
                v-else-if="index === 5"
                class="ml-2 grey--text text--darken-1 caption"
              >
                + ещё {{ data_local.outbound_carousels.length - 5 }}
              </span>
            </template>
          </v-autocomplete>

          <div class="add_new" v-if="!hasActiveCarousels">
            Нет активных каруселей, перейдите в раздел
            <router-link to="/numbers">«Номера»</router-link>
            для выделения активной карусели.
          </div>
        </div>
        <v-expansion-panels v-model="advanced_panel">
          <v-expansion-panel class="my_expand_panel">
            <v-expansion-panel-header>
              Расширенные настройки
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <div class="pt-4 region-head">
                <v-checkbox
                  v-model="regions_enabled"
                  label="Настроить регионы"
                  color="#4B5EFF"
                />
                <div class="regions-btn">
                  <v-btn
                    icon
                    small
                    :disabled="!regions_enabled"
                    @click.stop="toggleRegionsOpen"
                    :title="
                      regions_open ? 'Скрыть регионы' : 'Показать регионы'
                    "
                  >
                    <v-icon size="32">{{
                      regions_open ? 'mdi-chevron-up' : 'mdi-chevron-down'
                    }}</v-icon>
                  </v-btn>
                </div>
              </div>

              <v-expand-transition>
                <div v-show="regions_enabled && regions_open">
                  <v-checkbox
                    @click.stop
                    label="Выбрать всё"
                    color="#4B5EFF"
                    :input-value="allRegionsSelected"
                    :indeterminate="someRegionsSelected && !allRegionsSelected"
                    @change="toggleSelectAllRegions"
                  />

                  <div class="heading">Регионы</div>
                  <v-combobox
                    class="p2"
                    v-model="data_local.regions_selected"
                    :menu-props="{ top: true, offsetY: true }"
                    :items="regions"
                    multiple
                    chips
                    deletable-chips
                    hide-details
                    item-color="#4B5EFF"
                    @copy.native="copyRegions"
                    @paste.native="pasteRegions"
                  />
                </div>
              </v-expand-transition>

              <div class="pt-4 region-head">
                <v-checkbox
                  v-model="operators_enabled"
                  label="Настроить операторов"
                  color="#4B5EFF"
                />
                <div class="regions-btn">
                  <v-btn
                    icon
                    small
                    :disabled="!operators_enabled"
                    @click.stop="toggleOperatorsOpen"
                    :title="
                      operators_open
                        ? 'Скрыть операторов'
                        : 'Показать операторов'
                    "
                  >
                    <v-icon size="32">{{
                      operators_open ? 'mdi-chevron-up' : 'mdi-chevron-down'
                    }}</v-icon>
                  </v-btn>
                </div>
              </div>

              <v-expand-transition>
                <div v-show="operators_enabled && operators_open">
                  <v-checkbox
                    @click.stop
                    label="Выбрать всё"
                    color="#4B5EFF"
                    :input-value="allOperatorsSelected"
                    :indeterminate="
                      someOperatorsSelected && !allOperatorsSelected
                    "
                    @change="toggleSelectAllOperators"
                  />

                  <div class="heading">Операторы</div>
                  <v-combobox
                    class="p2"
                    v-model="data_local.operators_selected"
                    :menu-props="{ top: true, offsetY: true }"
                    :items="operators"
                    multiple
                    chips
                    deletable-chips
                    hide-details
                    item-color="#4B5EFF"
                    @copy.native="copyOperators"
                    @paste.native="pasteOperators"
                  >
                  </v-combobox>
                </div>
              </v-expand-transition>

              <div class="heading">Дата и время отложенного запуска</div>
              <div class="date_time">
                <div class="input_wrap">
                  <v-menu
                    v-model="data_local.menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="rel" v-bind="attrs" v-on="on">
                        <v-text-field
                          v-model="data_local.date"
                          readonly
                          height="32"
                          hide-details
                          class="input_datetime"
                        />
                        <div @click="clearDateTimeDefer('date')">
                          <Icon
                            v-on="on"
                            v-if="data_local.date"
                            class="close-date-picker"
                            name="close"
                          />
                        </div>
                        <Icon
                          v-if="!data_local.date"
                          class="abs"
                          name="calendar"
                        />
                      </div>
                    </template>
                    <v-date-picker
                      v-model="data_local.date"
                      @input="data_local.menu1 = false"
                      locale="ru"
                      color="#4B5EFF"
                      class="m-w-200p"
                      no-title
                      first-day-of-week="1"
                    />
                  </v-menu>
                </div>

                <div class="input_wrapper">
                  <v-menu
                    ref="menu"
                    v-model="data_local.menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="rel">
                        <v-text-field
                          v-model="data_local.time"
                          readonly
                          height="32"
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                          class="input_datetime w-80p"
                        />
                        <div @click="clearDateTimeDefer('time')">
                          <Icon
                            v-if="data_local.time"
                            class="close-date-picker"
                            name="close"
                          />
                        </div>
                      </div>
                    </template>
                    <v-time-picker
                      v-if="data_local.menu2"
                      v-model="data_local.time"
                      format="24hr"
                      color="#4B5EFF"
                      @click:minute="$refs.menu.save(data_local.time)"
                    />
                  </v-menu>
                </div>
              </div>

              <div class="row_wrapper">
                <div class="heading">
                  Добавить действия с номерами которым не получилось дозвонится
                </div>
                <div class="plus" @click="addOptionsNoCall()">
                  <Icon name="plus" />
                </div>
              </div>

              <div
                v-for="(option, key) in data_local.options_no_call"
                :key="key"
              >
                <div class="row_wrapper">
                  <v-select
                    class="mih40"
                    height="40"
                    hide-details
                    item-color="#4B5EFF"
                    :items="list_action"
                    item-value="id"
                    v-model="option.id"
                    item-text="name"
                    solo
                    placeholder="Выберите действие"
                    @change="changeOption(key)"
                  />
                  <div
                    class="minus mr-0 ml-2"
                    @click="deleteOptionsNoCall(key)"
                  >
                    <Icon name="minus" />
                  </div>
                </div>

                <div v-if="option.id === list_action[1].id">
                  <div class="heading">Укажите параметры интеграции</div>
                  <v-text-field
                    height="40"
                    placeholder="id"
                    v-model="option.options"
                  />
                </div>
              </div>

              <div class="heading">
                Попытки дозвониться
                <v-tooltip top max-width="300" color="#696969">
                  <template v-slot:activator="{ on, attrs }">
                    <span class="question" v-bind="attrs" v-on="on"
                      ><Icon name="question"
                    /></span>
                  </template>
                  <span>Минимум 1, максимум 4.</span>
                </v-tooltip>
              </div>

              <div class="input_wrapper">
                <div
                  class="minus"
                  @click="decrementCallAttempts"
                  :disabled="tryCallsDisplay <= 1"
                >
                  <Icon name="minus" />
                </div>
                <v-text-field
                  class="mini_input"
                  :value="tryCallsDisplay"
                  readonly
                  hide-details
                />
                <div
                  class="plus"
                  @click="incrementCallAttempts"
                  :disabled="tryCallsDisplay >= 4"
                >
                  <Icon name="plus" />
                </div>
              </div>

              <div class="heading">Через сколько минут перезванивать</div>
              <div class="input_wrapper">
                <div class="minus" @click="data_local.delay_call--">
                  <Icon name="minus" />
                </div>
                <v-text-field
                  type="number"
                  height="32"
                  class="mini_input"
                  min="0"
                  v-model="data_local.delay_call"
                />
                <div class="plus" @click="data_local.delay_call++">
                  <Icon name="plus" />
                </div>
              </div>
              <div class="heading">
                <v-checkbox
                  label="Использовать количество линий"
                  color="#4B5EFF"
                  v-model="data_local.use_lines_count"
                />
              </div>
              <div v-if="data_local.use_lines_count">
                <div class="heading">
                  Количество линий
                  <v-tooltip top max-width="300" color="#696969">
                    <template v-slot:activator="{ on, attrs }">
                      <span class="question" v-bind="attrs" v-on="on">
                        <Icon name="question" />
                      </span>
                    </template>
                    <span
                      >Количество одновременных линий для обзвона. Минимум 1,
                      максимум 1000.</span
                    >
                  </v-tooltip>
                </div>

                <div class="input_wrapper">
                  <div class="minus" @click="decrementLinesCount">
                    <Icon name="minus" />
                  </div>
                  <v-text-field
                    type="number"
                    height="32"
                    class="mini_input"
                    :min="1"
                    :max="1000"
                    v-model.number="data_local.lines_count"
                    hide-details
                    @blur="validateLinesCount"
                    @change="validateLinesCount"
                  ></v-text-field>
                  <div class="plus" @click="incrementLinesCount">
                    <Icon name="plus" />
                  </div>
                </div>
              </div>
              <div class="heading">
                <v-checkbox
                  label="Черный список по всем моим базам"
                  color="#4B5EFF"
                  v-model="data_local.all_blacklist"
                />
              </div>

              <div class="heading">
                <v-checkbox
                  label="Остановить по достижению цели"
                  color="#4B5EFF"
                  v-model="data_local.target_on"
                />
              </div>

              <div v-if="data_local.target_on">
                <v-select
                  class="mih40"
                  height="40"
                  v-model="data_local.target_name"
                  :items="targets"
                  item-color="#4B5EFF"
                  solo
                />
                <div class="input_wrapper">
                  <div class="minus" @click="data_local.limit--">
                    <Icon name="minus" />
                  </div>
                  <v-text-field
                    height="32"
                    class="mini_input"
                    min="0"
                    v-model="data_local.limit"
                  />
                  <div class="plus" @click="data_local.limit++">
                    <Icon name="plus" />
                  </div>
                </div>
              </div>

              <v-checkbox
                label="Использовать часовой пояс клиента"
                color="#4B5EFF"
                v-model="data_local.is_client_gtm"
              />
              <div class="heading">Учитывать время клиента</div>

              <div v-if="!data_local.is_client_gtm">
                <v-select
                  class="mih40"
                  height="40"
                  hide-details
                  item-color="#4B5EFF"
                  :items="listTimezoneRu"
                  item-value="gtm"
                  v-model="data_local.client_gtm"
                  item-text="name"
                  solo
                />
              </div>

              <div>
                <v-range-slider
                  v-model="data_local.range"
                  :max="24"
                  :min="0"
                  hide-details
                  track-fill-color="#4B5EFF"
                  thumb-color="#4B5EFF"
                  track-color="#AAABAD"
                  color="#4B5EFF"
                  class="align-center"
                >
                  <template v-slot:prepend>
                    <v-text-field
                      v-model="data_local.range[0]"
                      class="mt-0 pt-0 mini_input"
                      hide-details
                      single-line
                      type="number"
                      style="width: 40px; height: 40px"
                    />
                  </template>
                  <template v-slot:append>
                    <v-text-field
                      v-model="data_local.range[1]"
                      class="mt-0 pt-0 mini_input"
                      hide-details
                      single-line
                      type="number"
                      style="width: 40px; height: 40px; padding: 4px"
                    />
                  </template>
                </v-range-slider>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div class="add btn_save" @click="saveLocal" :disabled="saving">
          Сохранить
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Icon from '../../SetIcon.vue';

export default {
  components: { Icon },
  props: {
    show_dialog: Boolean,
    selected_calls: { type: Array, default: () => [] },
  },
  watch: {
    show_dialog(val) {
      this.dialog = val;
      if (!val) return;
      this.selectedNames = (this.selected_calls || []).map((c) => c.guid);
      const selectedItems = (this.selected_calls || []).map((c) => ({
        guid: c.guid,
        name: c.name,
      }));
      this.allCallNames = [...selectedItems, ...this.allCallNames].reduce(
        (acc, x) => {
          if (!acc.some((i) => i.guid === x.guid)) acc.push(x);
          return acc;
        },
        [],
      );

      const first = this.selected_calls?.[0];
      if (first) {
        this.data_local = JSON.parse(JSON.stringify(first));
      } else {
        this.data_local = this.defaultData();
      }

      // дефолты для исходящих
      if (
        !this.data_local.outbound_mode ||
        this.data_local.outbound_mode === 'standard'
      )
        this.data_local.outbound_mode = 'all_active';
      if (!Array.isArray(this.data_local.outbound_carousels))
        this.data_local.outbound_carousels = [];

      // регионы
      this.regions_init_lock = true;
      this.regions_enabled =
        Array.isArray(this.data_local.regions_selected) &&
        this.data_local.regions_selected.length > 0;
      this.operators_init_lock = true;
      this.operators_enabled =
        Array.isArray(this.data_local.operators_selected) &&
        this.data_local.operators_selected.length > 0;
      this.$nextTick(() => {
        this.regions_init_lock = false;
        this.operators_init_lock = false;
      });

      this.listDicts();
      this.listActiveCarousels(true);
      this.listScripts();
      this.calls_open = false;
    },

    'data_local.outbound_mode'(val, oldVal) {
      // if (val === 'standard') this.data_local.outbound_carousels = [];
      if (val === 'all_active')
        this.data_local.outbound_carousels = this.activeCarousels.map(
          (c) => c.id,
        );
      if (val === 'carousels' && oldVal === 'all_active')
        this.data_local.outbound_carousels = [];
    },

    regions_enabled(val) {
      if (this.regions_init_lock) return;
      if (val) {
        if (
          !Array.isArray(this.data_local.regions_selected) ||
          this.data_local.regions_selected.length === 0
        ) {
          this.data_local.regions_selected = [...this.regions];
        }
      } else {
        this.data_local.regions_selected = [];
      }
    },

    operators_enabled(val) {
      if (this.operators_init_lock) return;

      if (val) {
        if (
          !Array.isArray(this.data_local.operators_selected) ||
          this.data_local.operators_selected.length === 0
        ) {
          this.data_local.operators_selected = [...this.operators];
        }
      } else {
        this.data_local.operators_selected = [];
      }
    },

    'data_local.target_on'(newVal) {
      if (!newVal) {
        this.data_local.limit = 0;
        this.data_local.target_name = '';
      }
    },
  },
  mounted() {
    if (this.show_dialog) {
      this.loadAllCallNames();
    }
  },
  computed: {
    selectedCallsSummary() {
      const names = this.selectedCallNames || [];
      if (!names.length) return 'Ничего не выбрано';

      const first = String(names[0]);
      const rest = names.length - 1;

      return rest > 0 ? `${first} и ещё ${rest}` : first;
    },
    selectedCallNames() {
      const map = new Map(
        (this.allCallNames || []).map((x) => [x.guid, x.name]),
      );
      return (this.selectedNames || []).map((g) => map.get(g) || g);
    },
    selectedLabel() {
      const n = Array.isArray(this.selected_calls)
        ? this.selected_calls.length
        : 0;
      return `выбранные обзвоны ${n} шт.`;
    },
    tryCallsDisplay() {
      return (this.data_local.try_calls || 0) + 1;
    },
    allRegionsSelected() {
      return (
        Array.isArray(this.data_local.regions_selected) &&
        this.data_local.regions_selected.length === this.regions.length
      );
    },
    someRegionsSelected() {
      const n = Array.isArray(this.data_local.regions_selected)
        ? this.data_local.regions_selected.length
        : 0;
      return n > 0 && n < this.regions.length;
    },

    allOperatorsSelected() {
      return (
        Array.isArray(this.data_local.operators_selected) &&
        this.data_local.operators_selected.length === this.operators.length
      );
    },
    someOperatorsSelected() {
      const n = Array.isArray(this.data_local.operators_selected)
        ? this.data_local.operators_selected.length
        : 0;

      return n > 0 && n < this.operators.length;
    },
    carouselsRules() {
      return [
        (v) =>
          this.data_local.outbound_mode !== 'carousels' ||
          (Array.isArray(v) && v.length > 0) ||
          'Выберите хотя бы 1 карусель',
      ];
    },
  },
  methods: {
    defaultData() {
      return {
        menu1: false,
        menu2: false,
        range: [9, 18],
        target_on: false,
        all_blacklist: false,
        target_name: '',
        limit: 0,
        operators_selected: [],
        regions_selected: [],
        try_calls: 0,
        time: null,
        date: null,
        delay_call: 10,
        options_no_call: [],
        is_client_gtm: true,
        client_gtm: this.getTimeZone(),
        outbound_mode: 'all_active',
        outbound_carousels: [],
        use_lines_count: false,
        lines_count: 1,
      };
    },
    incrementLinesCount() {
      if (this.data_local.lines_count < 1000) {
        this.data_local.lines_count++;
      }
    },
    decrementLinesCount() {
      if (this.data_local.lines_count > 1) {
        this.data_local.lines_count--;
      }
    },
    validateLinesCount() {
      if (!this.data_local.lines_count || this.data_local.lines_count < 1) {
        this.data_local.lines_count = 1;
      } else if (this.data_local.lines_count > 1000) {
        this.data_local.lines_count = 1000;
      } else {
        this.data_local.lines_count = Math.floor(this.data_local.lines_count);
      }
    },
    saveLocal() {
      if (!this.selectedNames.length) return;

      // валидация каруселей
      if (
        this.data_local.outbound_mode === 'all_active' &&
        !this.hasActiveCarousels
      ) {
        alert(
          'Нет активных каруселей, перейдите в раздел «Номера» для выделения активной карусели',
        );
        return;
      }
      if (
        this.data_local.outbound_mode === 'carousels' &&
        (!Array.isArray(this.data_local.outbound_carousels) ||
          this.data_local.outbound_carousels.length === 0)
      ) {
        alert('Выберите хотя бы одну активную карусель для исходящих номеров');
        return;
      }
      if (
        this.operators_enabled &&
        (!Array.isArray(this.data_local.operators_selected) ||
          this.data_local.operators_selected.length === 0)
      ) {
        alert('Выберите хотя бы одного оператора');
        return;
      }
      if (!confirm('Применить настройки к выбранным обзвонам?')) {
        return;
      }
      this.saving = true;
      this.applyBulk();
    },
    applyBulk() {
      const patch = {};
      if (this.data_local.use_lines_count) {
        patch.use_lines_count = true;
        patch.lines_count = this.data_local.lines_count || 1;
      } else {
        patch.use_lines_count = false;
      }
      // исходящие номера — всегда считаем, что это bulk-настройка (или добавь чекбокс "менять исходящие")
      patch.outbound_mode = this.data_local.outbound_mode;
      patch.outbound_carousels = Array.isArray(
        this.data_local.outbound_carousels,
      )
        ? this.data_local.outbound_carousels
        : [];

      // регионы — у тебя уже есть флаг
      if (this.regions_enabled) {
        patch.regions_selected = Array.isArray(this.data_local.regions_selected)
          ? this.data_local.regions_selected
          : [];
      }

      if (this.operators_enabled) {
        patch.operators_selected = Array.isArray(
          this.data_local.operators_selected,
        )
          ? this.data_local.operators_selected
          : [];
      }

      // отложенный запуск — шлём только если реально задано
      if (this.data_local.date !== null) patch.date = this.data_local.date;
      if (this.data_local.time !== null) patch.time = this.data_local.time;

      // no-call options — шлём если есть
      if (
        Array.isArray(this.data_local.options_no_call) &&
        this.data_local.options_no_call.length
      ) {
        patch.options_no_call = this.data_local.options_no_call;
      }

      // попытки/задержка/диапазон
      patch.try_calls = this.data_local.try_calls;
      patch.delay_call = this.data_local.delay_call;
      patch.range = this.data_local.range;

      // чекбоксы
      patch.all_blacklist = this.data_local.all_blacklist;
      patch.target_on = this.data_local.target_on;

      const scenarioIds = [
        ...new Set(
          (this.selected_calls || [])
            .map((c) => c.select_scenario)
            .filter(Boolean),
        ),
      ];

      if (scenarioIds.length === 1) {
        if (this.data_local.target_on) {
          patch.target_name = this.data_local.target_name;
          patch.limit = this.data_local.limit;
        } else {
          patch.target_name = '';
          patch.limit = 0;
        }
      }

      // timezone
      patch.is_client_gtm = this.data_local.is_client_gtm;
      if (!this.data_local.is_client_gtm)
        patch.client_gtm = this.data_local.client_gtm;
      this.$http.post(
        '/call/bulkupdate',
        {
          guids: this.selectedNames,
          patch,
        },
        (res) => {
          console.log('ok', res);
          this.close();
          window.location.reload();
        },
      );
    },

    close() {
      this.saving = false;
      this.dialog = false;
      this.$emit('close');
    },

    // регионы
    toggleRegionsOpen() {
      if (!this.regions_enabled) return;
      this.regions_open = !this.regions_open;
    },
    toggleSelectAllRegions() {
      if (this.allRegionsSelected) this.data_local.regions_selected = [];
      else this.data_local.regions_selected = [...this.regions];
    },

    //операторы
    toggleOperatorsOpen() {
      if (!this.operators_enabled) return;
      this.operators_open = !this.operators_open;
    },
    toggleSelectAllOperators() {
      if (this.allOperatorsSelected) {
        this.data_local.operators_selected = [];
      } else {
        this.data_local.operators_selected = [...this.operators];
      }
    },

    // карусели
    listActiveCarousels(isEditing) {
      this.$http.post(
        '/numbers/carousel',
        { status: 'active', offset: 0, limit: 200, lite: true },
        (res) => {
          const items = Array.isArray(res) ? res : [];
          this.activeCarousels = items.map((x) => ({
            id: x.id,
            name: x.carousel,
          }));
          this.hasActiveCarousels = this.activeCarousels.length > 0;

          if (!isEditing) {
            this.data_local.outbound_mode = 'all_active';
          } else {
            if (!this.hasActiveCarousels) {
              this.data_local.outbound_mode = 'all_active';
              this.data_local.outbound_carousels = [];
            } else if (this.data_local.outbound_mode === 'carousels') {
              const activeIds = new Set(this.activeCarousels.map((c) => c.id));
              this.data_local.outbound_carousels = (
                this.data_local.outbound_carousels || []
              ).filter((id) => activeIds.has(id));
            }
          }

          if (this.data_local.outbound_mode === 'all_active') {
            this.data_local.outbound_carousels = this.activeCarousels.map(
              (c) => c.id,
            );
          }
        },
      );
    },

    // dicts (регионы)
    listDicts() {
      this.$http.post('/base/dicts', {}, (data) => {
        this.regions = data?.regions || [];
        this.operators = data?.operators || [];
      });
    },

    // попытки дозвона
    incrementCallAttempts() {
      if (this.tryCallsDisplay < 4) this.data_local.try_calls++;
    },
    decrementCallAttempts() {
      if (this.tryCallsDisplay > 1) this.data_local.try_calls--;
    },

    // дата/время
    clearDateTimeDefer(typeInput) {
      if (typeInput === 'date') this.data_local.date = null;
      if (typeInput === 'time') this.data_local.time = null;
    },

    getTimeZone() {
      const offset = new Date().getTimezoneOffset();
      const o = Math.abs(offset);
      return +((offset < 0 ? '' : '-') + ('00' + Math.floor(o / 60)).slice(-1));
    },

    // no-call options
    addOptionsNoCall() {
      if (
        this.data_local.options_no_call.length === 0 ||
        this.data_local.options_no_call[
          this.data_local.options_no_call.length - 1
        ].name_option !== ''
      ) {
        this.data_local.options_no_call.push({
          name_option: 'Выберите действие',
          options: '',
        });
      }
    },
    deleteOptionsNoCall(id) {
      this.data_local.options_no_call.splice(id, 1);
    },
    changeOption(key) {
      if (this.data_local.options_no_call[key].id !== 1) {
        delete this.data_local.options_no_call[key].options;
        delete this.data_local.options_no_call[key].name_option;
      }
    },
    loadAllCallNames() {
      // Пример запроса для получения всех обзвонов, если они не пришли
      this.$http.get('/api/calls').then((response) => {
        this.allCallNames = response.data.map((call) => ({
          guid: call.guid,
          name: call.name,
        }));
      });
    },
    listScripts() {
      this.scenaries = [];
      this.$http.post('/script/list', {}, (data) => {
        if (data) {
          data.forEach((item) => {
            this.scenaries.push({
              id: item.guid,
              name: item.name,
              data: item.data,
            });
          });
        }
        this.extractTargets();
      });
    },
    extractTargets() {
      this.targets = [];

      const scenarioIds = [
        ...new Set(
          (this.selected_calls || [])
            .map((c) => c.select_scenario)
            .filter(Boolean),
        ),
      ];

      // если сценарии разные — не показываем цели
      if (scenarioIds.length !== 1) {
        return;
      }

      const scenarioId = scenarioIds[0];

      this.scenaries.forEach((item) => {
        if (item.id == scenarioId && item.data) {
          const data = JSON.parse(item.data);
          for (let key in data) {
            if (data[key].type === 'target') {
              this.targets.push(data[key].data.name);
            }
          }
        }
      });
    },
    copyOperators(event) {
      const selected = Array.isArray(this.data_local.operators_selected)
        ? this.data_local.operators_selected
        : [];

      event.clipboardData.setData('text/plain', JSON.stringify(selected));
      event.preventDefault();
    },

    pasteOperators(event) {
      event.preventDefault();

      try {
        const text = event.clipboardData.getData('text/plain');
        const pasted = JSON.parse(text);

        if (!Array.isArray(pasted)) return;

        const allowedOperators = pasted.filter((operator) =>
          this.operators.includes(operator),
        );

        this.data_local.operators_selected = [...new Set(allowedOperators)];
      } catch (error) {
        return;
      }
    },
    copyRegions(event) {
      const selected = Array.isArray(this.data_local.regions_selected)
        ? this.data_local.regions_selected
        : [];

      event.clipboardData.setData('text/plain', JSON.stringify(selected));
      event.preventDefault();
    },

    pasteRegions(event) {
      event.preventDefault();

      try {
        const text = event.clipboardData.getData('text/plain');
        const pasted = JSON.parse(text);

        if (!Array.isArray(pasted)) return;

        const allowedRegions = pasted.filter((region) =>
          this.regions.includes(region),
        );

        this.data_local.regions_selected = [...new Set(allowedRegions)];
      } catch {
        return;
      }
    },
  },
  data() {
    return {
      calls_open: false,
      saving: false,
      confirmApply: false,
      dialog: false,
      selectedNames: [],
      allCallNames: [],
      advanced_panel: 0,

      // регионы
      regions: [],
      regions_enabled: false,
      regions_open: false,
      regions_init_lock: false,

      // операторы
      operators: [],
      operators_enabled: false,
      operators_open: false,
      operators_init_lock: false,

      // карусели
      activeCarousels: [],
      hasActiveCarousels: false,

      targets: [],
      scenaries: [],

      data_local: this.defaultData(),

      list_action: [
        { id: 0, name: 'Переместить в другую базу' },
        { id: 1, name: 'Интеграция с amoCRM' },
      ],
      listTimezoneRu: [
        { name: 'Калининград +02.00', gtm: 2 },
        { name: 'Москва +03.00', gtm: 3 },
        { name: 'Самара +04.00', gtm: 4 },
        { name: 'Екатеринбург +05.00', gtm: 5 },
        { name: 'Омск +06.00', gtm: 6 },
        { name: 'Красноярск +07.00', gtm: 7 },
        { name: 'Иркутск +08.00', gtm: 8 },
        { name: 'Якутск +09.00', gtm: 9 },
        { name: 'Владивосток +10.00', gtm: 10 },
        { name: 'Магадан +11.00', gtm: 11 },
        { name: 'Камчатка +12.00', gtm: 12 },
      ],
    };
  },
};
</script>

<style scoped>
.selected-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 0; /* чтобы выглядело как заголовок */
  border-radius: 12px; /* радиус */
  border: 0;
  margin-bottom: 6px; /* как у heading */
}

.selected-summary {
  margin: 0;
  margin-top: 16px; /* как у .heading */
  margin-bottom: 6px; /* как у .heading */
}

.selected-toggle .v-icon {
  margin-top: 16px; /* выравниваем по заголовку */
  margin-right: 6px;
  color: #404247;
}

.region-head {
  display: flex;
  align-items: center;
}

.regions-btn {
  display: flex;
  align-items: flex-end;
  margin-left: 15px;
  margin-bottom: 10px;
}

.close-date-picker {
  position: absolute;
  top: 9px;
  right: 9px;
}

* {
  user-select: none;
}

.my_expand_panel {
  padding: 0;
}

.my_expand_panel:before {
  box-shadow: none;
  /*border-radius: none;*/
}

.my_expand_panel .v-expansion-panel-content {
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.06), 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
}

.my_expand_panel .v-expansion-panel-header v-expansion-panel-header--active {
  padding: 0;
  min-height: initial;
}

.input_datetime {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #2b2d33;
  width: 200px;
}

.datepicker {
  position: absolute;
}

.date_time {
  display: flex;
}

.input_wrap {
  margin-right: 6px;
}

.input_wrapper {
  max-width: 65px;
}

.rel {
  position: relative;
}

.abs {
  position: absolute;
  top: 9px;
  right: 9px;
}

.heading {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 16px;
  color: #404247;
}

.input_wrapper {
  display: flex;
  align-items: center;
}

.mini_input {
  min-width: 63px;
  height: 32px;
  text-align: center;
  padding: 7px 12px;
}

.plus {
  border: 1px solid #4b5eff;
  border-radius: 8px;
  background: #fff;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  cursor: pointer;
  padding: 8px;
}

.minus {
  margin-right: 6px;
  border: 1px solid #4b5eff;
  border-radius: 8px;
  background: #fff;
  width: 32px;
  height: 32px;
  display: flex;
  padding: 16px 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.select_type .titler {
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
  text-align: left;
  margin-bottom: 13px;
  margin-top: 16px;
}

.question {
  cursor: pointer;
}

.tooltip {
  display: flex;
  align-items: baseline;
}

.tooltip .icon {
  margin-left: 8px;
}

.add_new {
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #4b5eff;
  width: max-content;
  margin-bottom: 16px;
  margin-top: 6px;
}

.add_new a {
  text-decoration: none;
}

.add_new:after {
  background: #4b5eff;
  content: '';
  display: block;
  height: 1px;
  width: 100%;
}

.rules {
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 130%;
  color: #aaabad;
  text-align: left;
  margin-bottom: 24px;
}

.cancel_btn {
  color: #4b5eff;
}
.add {
  border: none;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #eee;
  cursor: pointer;
  display: flex;
  margin-top: 24px;
  justify-content: center;
}

.add_sec {
  width: 100%;
  border: none;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  text-align: center;
  color: #eee;
  cursor: pointer;
  display: flex;
  margin-top: 24px;
  justify-content: center;
}

.add .icon {
  margin-right: 11px;
}

.add_modal {
  width: 100%;
  padding: 9px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 110%;
  color: #2b2d33;
}

.textarea {
  padding: 16px 0;
}

.subtitle {
  font-style: normal;
  text-align: left;
  font-weight: 700;
  font-size: 17px;
  line-height: 120%;
  color: #404247;
}

.wrapper {
  padding: 32px;
}

.modal_subtitle {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  margin-bottom: 6px;
  text-align: left;
  color: #404247;
  margin-bottom: 6px;
}

.modal_title {
  padding: 0 !important;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  margin-bottom: 24px;
  text-align: center;
  line-height: 130%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2b2d33;
}

.row_wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.m-w-200p {
  min-width: 80px;
}

.w-80p {
  width: 80px;
}
.chip-truncate .v-chip__content {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.truncate-line {
  display: block;
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
